// Recorded reference notes for the tuner (a classical guitar and an electric
// bass, see static_content/audio/tuner/README.md). Each file is a plucked
// string resampled to sound exactly at its MIDI note with A4 = 440 Hz; other
// notes and reference pitches are reached by changing the playback rate.

import { onset } from '../backing-track/sampler'
import { midiToFrequency } from './pitch'

const SOUNDS = {
    guitar: [40, 45, 50, 55, 59, 64, 69, 74, 79, 83],
    bass: [23, 28, 33, 38, 43],
}
const BASS_INSTRUMENTS = ['bass', 'bass_basic']

// Bump when the sample files change, so browsers and the CDN don't serve old ones.
const SAMPLES_VERSION = 1

const baseUrl = () => (window.AUDIO && window.AUDIO.tuner) || '/static/audio/tuner/'

export const referenceSoundFor = (instrument) => instrument && BASS_INSTRUMENTS.includes(instrument.safe_name) ? 'bass' : 'guitar'

const nearestNote = (sound, midi) => SOUNDS[sound].reduce((best, note) => Math.abs(note - midi) < Math.abs(best - midi) ? note : best)

// Decoded buffers can be played by any audio context, so samples are decoded
// once with an offline context and outlive the practice dock's, which is
// closed when the song page goes. The dock's chords panel strums with them too.
let decoder = null
const getDecoder = () => {
    if (!decoder) {
        const OfflineContextClass = window.OfflineAudioContext || window.webkitOfflineAudioContext
        decoder = new OfflineContextClass(1, 1, 44100)
    }
    return decoder
}

const loads = {}

// Resolves to { buffer, offset, midi }: the recorded note nearest to midi.
// Cached, so it's safe to call on every tap.
export const loadReferenceNote = (sound, midi) => {
    const note = nearestNote(sound, midi)
    const file = `${sound}/${note}.m4a`
    if (!loads[file]) {
        loads[file] = fetch(`${baseUrl()}${file}?v=${SAMPLES_VERSION}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${file}`)
                }
                return response.arrayBuffer()
            })
            .then(data => new Promise((resolve, reject) => getDecoder().decodeAudioData(data, resolve, reject)))
            .then(buffer => ({ buffer, offset: onset(buffer), midi: note }))
            .catch(error => {
                delete loads[file]
                throw error
            })
    }
    return loads[file]
}

export const playbackRate = (sample, midi, a4) => midiToFrequency(midi, a4) / midiToFrequency(sample.midi)
